// These are the proplyds candidates 
export const proplydsCsv = `Name,RA,DEC
4596-400,83.74794769066474,-5.400070178067461
005-514,83.75173935733135,-5.42062573362302
044-527,83.76823935733134,-5.42426462251191
d053-717,83.77232269066474,-5.45476462251191
064-705,83.77653102399805,-5.451292400289691
066-652,83.77728102399804,-5.447764622511911
069-600,83.77857269066475,-5.43351462251191
d072-135,83.77978102399804,-5.3595424002896905
073-227,83.78007269066474,-5.3740424002896905
097-125,83.79011435733133,-5.356903511400801
102-233,83.79203102399804,-5.3757368447341305
102-021,83.79223935733134,-5.339181289178571
106-156,83.79382269066474,-5.365625733623021
106-417,83.79369769066474,-5.40462573362302
d109-247,83.79519769066474,-5.37954240028969
d109-327,83.79536435733134,-5.390709066956351
109-449,83.79536435733134,-5.413514622511911
d110-3035,83.79557269066474,-5.50976462251191
d114-426,83.79690602399803,-5.407320178067461
117-025,83.79861435733135,-5.34029240028969
d117-352,83.79861435733135,-5.3977090669563506
119-340,83.79936435733134,-5.3944035114008
d121-192,83.80015602399804,-5.32354240028969
121-434,83.80028102399804,-5.4094035114008
d124-132,83.80136435733134,-5.35873684473413
131-046,83.80419769066474,-5.34607017806746
131-247,83.80436435733134,-5.37979240028969
d132-042,83.80494769066473,-5.34495906695635
d132-183,83.80490602399804,-5.3091535114008
d135-220,83.80607269066473,-5.37209795584524
138-207,83.80723935733134,-5.36862573362302
139-320,83.80778102399805,-5.38893128917857
140-1952,83.80832269066474,-5.33112573362302
d141-520,83.80832269066474,-5.42232017806746
d141-301,83.80873935733133,-5.38362573362302
143-425,83.80919769066475,-5.40687573362302
d143-522,83.80953102399803,-5.42282017806746
144-334,83.80969769066473,-5.3926812891785705
d147-323,83.81111435733133,-5.3897090669563505
150-231,83.81236435733133,-5.3752924002896805
152-319,83.81311435733134,-5.388570178067461
152-738,83.81315602399803,-5.46048684473413
153-1902,83.81373935733134,-5.31726462251191
154-324,83.81373935733134,-5.3900424002896905
154-225,83.81382269066474,-5.3737090669563505
d154-240,83.81386435733134,-5.3777646225119105
d155-338,83.81444769066474,-5.39373684473413
156-403,83.81482269066474,-5.400847955845241
157-533,83.81507269066473,-5.42584795584524
157-323,83.81528102399804,-5.38957017806746
d158-326,83.81557269066474,-5.39073684473413
d158-327,83.81578102399804,-5.39043128917857
158-323,83.81573935733134,-5.38957017806746
159-338,83.81603102399804,-5.3938757336230205
d159-418,83.81603102399804,-5.40493128917857
159-350,83.81623935733134,-5.397209066956351
160-353,83.81644769066475,-5.39807017806746
161-324,83.81669769066474,-5.39009795584524
d161-328,83.81673935733134,-5.39107017806746
161-314,83.81686435733134,-5.387292400289691
163-317,83.81761435733134,-5.387931289178571
d163-026,83.81765602399804,-5.3404035114008
d163-222,83.81769769066474,-5.3726535114008005
163-249,83.81782269066474,-5.38029240028969
164-511,83.81794769066474,-5.41932017806746
165-235,83.81844769066474,-5.37643128917857
d165-254,83.81869769066473,-5.38157017806746
166-519,83.81886435733134,-5.42157017806746
166-250,83.81890602399804,-5.3806535114008005
166-316,83.81898935733133,-5.387820178067461
d167-231,83.81948935733134,-5.375347955845241
167-317,83.81957269066474,-5.387820178067461
168-328,83.81961435733135,-5.39112573362302
168-235,83.81990602399804,-5.37626462251191
168-326,83.81994769066473,-5.39062573362302
169-338,83.82011435733133,-5.393903511400801
d170-249,83.82048935733134,-5.38018128917857
170-337,83.82061435733134,-5.39362573362302
d171-340,83.82082269066474,-5.39437573362302
171-334,83.82086435733135,-5.3927924002896805
d172-028,83.82153102399803,-5.341014622511911
173-341,83.82194769066474,-5.394847955845241
d174-236,83.82203102399804,-5.376597955845241
174-414,83.82223935733134,-5.40379240028969
175-251,83.82261435733135,-5.38093128917857
d175-355,83.82286435733134,-5.39862573362302
d176-543,83.82290602399804,-5.42851462251191
176-325,83.82290602399804,-5.3902368447341305
d177-341,83.82340602399805,-5.39468128917857
177-454,83.82348935733134,-5.41495906695635
d177-541,83.82357269066473,-5.42798684473413
177-444,83.82365602399804,-5.4120979558452404
d179-353,83.82461435733134,-5.39820906695635
180-331,83.82494769066474,-5.39187573362302
d181-247,83.82511435733134,-5.37973684473413
d181-825,83.82519769066474,-5.473597955845241
d182-332,83.82557269066474,-5.392097955845241
d182-413,83.82569769066474,-5.403709066956351
182-316,83.82578102399803,-5.387681289178571
183-439,83.82594769066473,-5.410736844734131
d183-419,83.82607269066474,-5.405209066956351
d183-405,83.82615602399804,-5.40129240028969
184-427,83.82623935733135,-5.4074035114008
184-520,83.82665602399804,-5.42198684473413
189-329,83.82840602399804,-5.391347955845241
191-350,83.82923935733135,-5.397070178067461
d191-232,83.82946852399805,-5.37537573362302
d197-427,83.83169769066474,-5.407320178067461
198-222,83.83236435733134,-5.3726535114008005
198-448,83.83244769066474,-5.41326462251191
201-534,83.83373935733134,-5.426014622511911
202-228,83.83373935733134,-5.37451462251191
d203-504,83.83423935733134,-5.41773684473413
d203-506,83.83444769066475,-5.418181289178571
205-330,83.83503102399804,-5.39157017806746
205-052,83.83528102399804,-5.34779240028969
d205-421,83.83536435733134,-5.40576462251191
d206-446,83.83573935733133,-5.4128479558452405
208-122,83.83661435733134,-5.35595906695635
212-557,83.83794769066473,-5.43245906695635
212-260,83.83828102399804,-5.38318128917857
213-346,83.83857269066473,-5.39609795584524
215-317,83.83940602399804,-5.387931289178571
d216-0939,83.83965602399805,-5.16079240028969
218-339,83.84048935733134,-5.394209066956351
d218-354,83.84065602399804,-5.3982368447341305
d218-529,83.84073935733134,-5.424514622511911
221-433,83.84182269066474,-5.40907017806746
224-728,83.84303102399804,-5.45784795584524
228-548,83.84490602399804,-5.429847955845241
231-502,83.84628102399805,-5.417264622511911
232-453,83.84648935733134,-5.4146535114008
236-527,83.84811435733134,-5.423986844734131
237-627,83.84836435733133,-5.440820178067461
d239-334,83.84923935733134,-5.39276462251191
239-510,83.84969769066474,-5.419375733623021
240-314,83.84998935733134,-5.3871535114008005
242-519,83.85086435733135,-5.421820178067461
d244-440,83.85161435733134,-5.41104240028969
245-632,83.85169769066474,-5.44204240028969
245-502,83.85190602399804,-5.41707017806746
247-436,83.85269769066474,-5.4098757336230205
250-439,83.85407269066474,-5.410653511400801
d252-457,83.85482269066473,-5.41587573362302
d253-1536,83.85519769066474,-5.259847955845241
264-532,83.85986435733133,-5.4254035114008
d280-1720,83.86661435733134,-5.288931289178571
282-458,83.86732269066474,-5.416153511400801
d294-606,83.87261435733134,-5.4351535114008005
d347-1535,83.89423935733134,-5.2596535114008`